// extracted by mini-css-extract-plugin
export var cardDeck = "ArticleCallOutCardDeck-module--cardDeck--14m_x";